import React from 'react';
import { useTranslation } from 'react-i18next';
import { PredictorStatPrize } from '../../interfaces/predictors';
import { TFunction } from 'i18next';
import reactStringReplace from 'react-string-replace';
import './PayoutTableItem.scss';
import DisplayCurrencyOrPrizeSuffix from '../DisplayPrizeCurrencyOrSuffix/DisplayPrizeCurrencyOrSuffix';
import { getPrizeCodeClassModifier, getPrizeSuffixTranslationKey } from '../PrizePool/PrizePool.functions';

export interface PayoutTableItemProps {
  correct: number | undefined;
  total: number | undefined;
  players: string | undefined;
  prize: PredictorStatPrize | undefined;
  focused: boolean;
}

const getResultText = ({
  correct,
  total,
  t,
}: {
  correct: number | undefined;
  total: number | undefined;
  t: TFunction;
}) => {
  if (correct === undefined || total === undefined) return <div className='payout-table-item__text__col2'>-</div>;
  return (
    <div className={'payout-table-item__text__col1'}>
      {reactStringReplace(t('payout-table-result-amount'), /({{total}}|{{correct}})/g, (match, index) => {
        let col = '';
        if (match === '{{correct}}') col = 'correct';
        else if (match === '{{total}}') col = 'total';
        return (
          <div key={col} className={`payout-table-item__text__${col}`}>
            {col === 'correct' ? correct : total}
          </div>
        );
      })}
    </div>
  );
};

const PayoutTableItem = ({ correct, total, players, prize, focused }: PayoutTableItemProps) => {
  const { t } = useTranslation();

  const prizeCodeClassModifier = getPrizeCodeClassModifier({ prizeCode: prize?.prizeCode });
  const suffixTranslationKey = getPrizeSuffixTranslationKey({ prizeCode: prize?.prizeCode });

  return (
    <div className={`payout-table-item ${focused ? 'focused' : ''}`}>
      <div className={'payout-table-item__text'}>{getResultText({ correct, total, t })}</div>
      <div className={'payout-table-item__text'}>
        <div className='payout-table-item__text__col2'>{players ?? '-'}</div>
      </div>
      <div className={'payout-table-item__text'}>
        <div
          className={
            prizeCodeClassModifier
              ? `payout-table-item__text__col3 payout-table-item__text__col3${prizeCodeClassModifier}`
              : 'payout-table-item__text__col3'
          }
        >
          {prize ? (
            <DisplayCurrencyOrPrizeSuffix
              value={prize.prizeAmount}
              currency={prize.prizeCurrencyCode}
              prizeCode={prize.prizeCode}
              prizeMultiplier={prize.prizeMultiplier}
              suffix={suffixTranslationKey}
            />
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  );
};

export default PayoutTableItem;
